/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { Cite, Slide, Heading, Text, Box, FlexBox, Image, Appear, Markdown } from "spectacle";
import {LeftContentRightContent, LeftCodeRightContent, LeftCodeRightMarkdown, LeftContentRightMarkdown, LeftCodeRightCode} from "components/layout";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */



const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const TitleDummy = makeShortcode("TitleDummy");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* prettier-ignore-start */
    }
    {
      /* prettier-ignore-end */
    }
    <TitleDummy mdxType="TitleDummy" />
    <h1>{`Redux Docs Updates`}</h1>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperSlide1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Core Docs Rewrite`}</h4>
    <ul>
      <li parentName="ul">{`Problems with original docs (`}<a parentName="li" {...{
          "href": "https://github.com/reduxjs/redux/issues/2590"
        }}>{`Issue #2590: General docs review`}</a>{`)`}
        <ul parentName="li">
          <li parentName="ul">{`Originally written in 2015, to target a different audience`}
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://twitter.com/dan_abramov/status/622567874796855296"
                }}>{`Dan Abramov on Twitter, 2015: "so hard to write the new docs - many audiences to cater to. Flux beginners, FP people, normal JS people"`}</a></li>
              <li parentName="ul">{`Assumptions about "Flux wars"`}</li>
              <li parentName="ul">{`Comparisons to things like Backbone`}</li>
            </ul>
          </li>
          <li parentName="ul">{`Tutorials are shallow and don't get into "real-world" usage`}</li>
          <li parentName="ul">{`Unclear learning flow`}</li>
          <li parentName="ul">{`"Recipes" section is a bunch of random content`}</li>
          <li parentName="ul">{`"Usage with React" page emphasizes "containers" unnecessarily`}</li>
          <li parentName="ul">{`Lack of info on `}<em parentName="li">{`why`}</em>{` and `}<em parentName="li">{`when`}</em>{` you should use Redux`}</li>
          <li parentName="ul">{`Deliberately unopinionated almost everywhere`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide1.isMDXComponent = true;

function MDXContentWrapperSlide2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Core Docs Rewrite`}</h4>
    <ul>
      <li parentName="ul">{`Ongoing docs revamp (`}<a parentName="li" {...{
          "href": "https://github.com/reduxjs/redux/issues/3313"
        }}>{`Issue #3313: Revamped docs content, structure, and teaching flow`}</a>{`):`}
        <ul parentName="li">
          <li parentName="ul">{`Reorganize current content into more logical structures`}</li>
          <li parentName="ul">{`Provide "learning paths" for different types of users`}</li>
          <li parentName="ul">{`Rework tutorials`}
            <ul parentName="li">
              <li parentName="ul">{`Clarify how Redux works, from bare-bones up to large apps`}</li>
              <li parentName="ul">{`Switch from "folder-by-type" to "feature folder" structures`}</li>
            </ul>
          </li>
          <li parentName="ul">{`More info on how to use Redux with (and without) various UI frameworks`}
            <ul parentName="li">
              <li parentName="ul">{`Rewrite "Usage with React" tutorial`}</li>
            </ul>
          </li>
          <li parentName="ul">{`"Style Guide" page with opinionated suggestions and best practices`}</li>
          <li parentName="ul">{`New "Real-World Usage" section`}
            <ul parentName="li">
              <li parentName="ul">{`Discuss app structures, async, selectors, etc`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide2.isMDXComponent = true;

function MDXContentWrapperSlide3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`New "Redux Essentials" Tutorial`}</h4>
    <ul>
      <li parentName="ul">{`Spent first half of 2020 writing a new 25K-word "Redux Essentials" tutorial sequence`}
        <ul parentName="li">
          <li parentName="ul">{`Teaches Redux Toolkit and React-Redux hooks as the default way to use Redux `}</li>
          <li parentName="ul">{`Uses a "top-down" / "how to use it the right way" teaching approach`}</li>
          <li parentName="ul">{`Builds a "real-world" example app that teaches Redux concepts and covers all of the RTK and React-Redux APIs`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Took inspiration from numerous other docs sites and tutorials`}
        <ul parentName="li">
          <li parentName="ul">{`"What You'll Learn / What You've Learned" summaries`}</li>
          <li parentName="ul">{`Info/Tip/Caution/Warning callout boxes and "Detailed Explanation" expandable sections `}</li>
          <li parentName="ul">{`Diagrams and embedded runnable CodeSandboxes`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Now linked as the default "Tutorial" on the header `}</li>
    </ul>
    <h5><a parentName="h5" {...{
        "href": "https://redux.js.org/tutorials/essentials/part-1-overview-concepts"
      }}>{`Redux Essentials, Part 1: Overview and Concepts`}</a></h5>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide3.isMDXComponent = true;

function MDXContentWrapperSlide4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`New "Redux Fundamentals" Tutorial`}</h4>
    <ul>
      <li parentName="ul">{`Original "Basics/Advanced" tutorial had many flaws (`}<a parentName="li" {...{
          "href": "https://github.com/reduxjs/redux/issues/3855"
        }}>{`issue #855`}</a>{`):`}
        <ul parentName="li">
          <li parentName="ul">{`Outdated references to "Flux", etc`}</li>
          <li parentName="ul">{`Unclear code examples`}</li>
          <li parentName="ul">{`Showed practices we no longer recommed ( `}<inlineCode parentName="li">{`/reducers`}</inlineCode>{` folder, "container components", `}<inlineCode parentName="li">{`const ADD_TODO = 'ADD_TODO'`}</inlineCode>{`)`}</li>
        </ul>
      </li>
      <li parentName="ul">{`In second half 2020, wrote a new "Redux Fundamentals" tutorial to replace the "Basics" sequence`}
        <ul parentName="li">
          <li parentName="ul">{`Still need a low-level, "how the mechanics work" tutorial sequence that shows writing Redux code "by hand"`}</li>
          <li parentName="ul">{`Covers same concepts (actions, reducers, store, usage with React, async), but rewrites 90% of the content `}</li>
          <li parentName="ul">{`Shows single-file "slice file" pattern, React-Redux hooks, `}<inlineCode parentName="li">{`"todos/todoAdded"`}</inlineCode>{` types`}</li>
          <li parentName="ul">{`Adds overview of Redux concepts, standard usage patterns, and finishes by showing how RTK simplifies the existing hand-written Redux logic`}</li>
          <li parentName="ul">{`Real working example todo app, with CodeSandboxes`}</li>
        </ul>
      </li>
    </ul>
    <h5><a parentName="h5" {...{
        "href": "https://redux.js.org/tutorials/fundamentals/part-1-overview"
      }}>{`Redux Fundamentals, Part 1: Overview`}</a></h5>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide4.isMDXComponent = true;

function MDXContentWrapperSlide5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Redux Style Guide`}</h4>
    <ul>
      <li parentName="ul">{`Lists official "opinionated" patterns and practices `}</li>
      <li parentName="ul">{`"Essential":`}
        <ul parentName="li">
          <li parentName="ul">{`no mutation`}</li>
          <li parentName="ul">{`no side effects in reducers`}</li>
          <li parentName="ul">{`one store`}</li>
        </ul>
      </li>
      <li parentName="ul">{`"Strongly Recommended": `}
        <ul parentName="li">
          <li parentName="ul">{`Use RTK`}</li>
          <li parentName="ul">{`Structure logic as "ducks/slice" files`}</li>
          <li parentName="ul">{`More logic in reducers`}</li>
          <li parentName="ul">{`Model actions as "events", not "setters"`}</li>
          <li parentName="ul">{`Use React-Redux hooks`}</li>
          <li parentName="ul">{`Use static typing`}</li>
          <li parentName="ul">{`Use plain JS objects, not Immutable.js`}</li>
        </ul>
      </li>
      <li parentName="ul">{`"Recommended":`}
        <ul parentName="li">
          <li parentName="ul">{`Write actions as `}<inlineCode parentName="li">{`"domain/eventName"`}</inlineCode></li>
          <li parentName="ul">{`Use Flux Standard Action structure `}</li>
          <li parentName="ul">{`Use thunks for async `}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide5.isMDXComponent = true;

function MDXContentWrapperSlide6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Other Docs Needs`}</h4>
    <ul>
      <li parentName="ul">{`Redux core docs:`}
        <ul parentName="li">
          <li parentName="ul">{`Need to create new pages for a "Using Redux" category`}</li>
          <li parentName="ul">{`Many existing pages need to be updated to match current recommended patterns`}</li>
        </ul>
      </li>
      <li parentName="ul">{`React-Redux docs:`}
        <ul parentName="li">
          <li parentName="ul">{`Tutorial still teaches `}<inlineCode parentName="li">{`connect`}</inlineCode>{` as default - rewrite in progress`}</li>
          <li parentName="ul">{`Needs a hooks usage guide page`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Redux Toolkit docs:`}
        <ul parentName="li">
          <li parentName="ul">{`Need "Migrating to RTK" page`}</li>
          <li parentName="ul">{`Need a better approach for showing TS definitions in API reference`}</li>
        </ul>
      </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide6.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;

function MDXContentWrapperNotes1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes1.isMDXComponent = true;

function MDXContentWrapperNotes2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes2.isMDXComponent = true;

function MDXContentWrapperNotes3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes3.isMDXComponent = true;

function MDXContentWrapperNotes4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes4.isMDXComponent = true;

function MDXContentWrapperNotes5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes5.isMDXComponent = true;

function MDXContentWrapperNotes6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes6.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0,MDXContentWrapperNotes1,MDXContentWrapperNotes2,MDXContentWrapperNotes3,MDXContentWrapperNotes4,MDXContentWrapperNotes5,MDXContentWrapperNotes6];


export default [MDXContentWrapperSlide0,MDXContentWrapperSlide1,MDXContentWrapperSlide2,MDXContentWrapperSlide3,MDXContentWrapperSlide4,MDXContentWrapperSlide5,MDXContentWrapperSlide6]